// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3R5nv","colBig":"styles_colBig__1PAm-","colSmall":"styles_colSmall__2Yfdv"};